import i18n from '../../utils/i18n'

export default [
  {
    title: i18n.t('my3'), // '我的资金',
    isOpen: false,
    isShow: true,
    icon: 'fund',
    navChild: [
      {
        title: i18n.t('index5'), // '入金',
        isShow: true,
        name: 'publicDeposit'
      },
      {
        title: i18n.t('index7'), // '转账',
        isShow: true,
        name: 'transfer'
      },
      {
        title: i18n.t('index6'), // '出金',
        isShow: true,
        name: 'publicWithdrawal'
      },
      {
        title: i18n.t('index8'), // '钱包',
        isShow: true,
        name: 'wallet'
      },
      {
        title: i18n.t('my5'), // '入金记录',
        isShow: true,
        name: 'publicDepositRecord'
      },
      {
        title: i18n.t('my45'), // '出金记录',
        isShow: true,
        name: 'publicWithdrawalRecord'
      },
      {
        title: i18n.t('my124'), // '账户转账记录',
        isShow: true,
        name: 'proxyTransferRecord'
      }
    ]
  },
  {
    title: i18n.t('proxymoney3'),
    isOpen: false,
    isShow: false,
    icon: 'audit',
    navChild: [
      {
        title: i18n.t('proxymoney4'), // '代理入金审核',
        isShow: true,
        name: 'proxyAgentDeposit'
      },
      {
        title: i18n.t('public2'), // 代理出金审核
        isShow: true,
        name: 'proxyAuditWithdrawal'
      },
      {
        title: i18n.t('proxymoney77'), // '客户入金审核',
        isShow: true,
        name: 'proxyCustomerDeposit'
      },
      {
        title: i18n.t('proxymoney115'), // '客户出金审核',
        isShow: true,
        name: 'proxyCustomerWithdrawal'
      }
    ]
  },
  {
    title: i18n.t('promotionCenter'),
    isOpen: false,
    isShow: true,
    icon: 'sub',
    navChild: [
      { title: i18n.t('promotionCenter'), isShow: true, name: 'proxyPromotionCenter' },
      { title: i18n.t('invitationDetailsV2'), isShow: true, name: 'proxyInvitationDetail' },
      { title: i18n.t('commissionDetailsV2'), isShow: true, name: 'proxyCommissionDetailsNew' }
    ]
  },
  {
    title: i18n.t('proxybonusgroup1'), // '用户成长赠金报表'
    isOpen: false,
    isShow: true,
    icon: 'bonus-growth',
    navChild: [
      {
        title: i18n.t('text99'), // '用户每日成长赠金'
        isShow: true,
        name: 'userMiningRewards'
      },
      {
        title: i18n.t('text100'), // '每日成长赠金明细'
        isShow: true,
        name: 'miningRewardDetails'
      },
      {
        title: i18n.t('text101'), // '激活记录明细'
        isShow: true,
        name: 'activationRecordDetails'
      }
    ]
  },
  {
    title: i18n.t('proxybonusgroup2'), // '用户风险补偿报表'
    isOpen: false,
    isShow: true,
    icon: 'bonus-risk',
    navChild: [
      {
        title: i18n.t('text45'), // '用户风险补偿赠金'
        isShow: true,
        name: 'userBonus'
      },
      {
        title: i18n.t('text46'), // '风险补偿赠金计算明细'
        isShow: true,
        name: 'bonusCalculationDetails'
      },
      {
        title: i18n.t('text47'), // '风险补偿赠金使用明细'
        isShow: true,
        name: 'detailsBonusUsage'
      },
      {
        title: i18n.t('text48'), // '佣金明细'
        isShow: true,
        name: 'bonusDetails'
      }
      // {
      //   title: i18n.t('text108'), // '跑马灯记录'
      //   isShow: true,
      //   name: 'opxDrawings'
      // }
    ]
  },
  {
    title: i18n.t('proxycust3'), // '用户管理',
    isOpen: false,
    isShow: true,
    icon: 'use',
    navChild: [
      {
        title: i18n.t('public4'), // '用户明细',
        isShow: true,
        name: 'proxyCustomerList'
      }
      // {
      //   title: '交易费用明细',
      //   isShow: true,
      //   name: 'customerManageTransactionDetail'
      // }
    ]
  },
  {
    title: i18n.t('public6'), // '资金管理',
    isOpen: false,
    isShow: true,
    icon: 'money',
    navChild: [
      {
        title: i18n.t('proxymoneymanage4'), // '客户交易账户转账明细',
        isShow: true,
        name: 'proxyCustomerTransferDetails'
      },
      {
        title: i18n.t('proxymoneymanage25'), // '佣金明细',
        isShow: true,
        name: 'proxyCommissionDetail'
      }
    ]
  },
  {
    title: i18n.t('index20'), // '个人信息',
    isOpen: false,
    isShow: true,
    icon: 'my',
    name: 'proxyInfo'
  },
  {
    title: i18n.t('user87'), // 'Notifications',
    name: 'message',
    isOpen: false,
    isShow: true,
    icon: 'not'
  }
  // {
  //   title: 'Downloads',
  //   name: 'down',
  //   isOpen: false,
  //   isShow: true,
  //   icon: 'down'
  // }
]
